module.exports = {
  siteTitle: 'Oxyzone', // Site title.
  siteTitleAlt: 'Oxyone', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://oxyzone.life', // Domain of your website without pathPrefix.
  pathPrefix: '',
  siteDescription: 'Oxyzone green solutions.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'oxyzone', // Disqus shortname.
  userName: 'Sai Teja Talasila',
  userTwitter: '',
  userLocation: 'Hyderabad, India',
  userDescription: '',
  copyright: 'Copyright © Oxyzone Pvt Ltd 2019. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}
